import { render, staticRenderFns } from "./seat-selection.vue?vue&type=template&id=54e21201"
import script from "./seat-selection.vue?vue&type=script&lang=js"
export * from "./seat-selection.vue?vue&type=script&lang=js"
import style0 from "./seat-selection.vue?vue&type=style&index=0&id=54e21201&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports